<template>
  <div class="gameList">
    <div
      class="li"
      v-for="(item, index) in gameList"
      :key="index"
      @click.stop="toGame(item.id)"
    >
      <div class="top">
        <img class="li_icon" :src="item.icon" alt="" />
        <div class="li_middle">
          <div class="li_middle_top">
            <span class="li_title">{{ item.name }}</span>
            <span class="li_gift_text">{{ item.titleSuffix }}</span>
            <div class="li_gift_type">
              <div
                class="li_gift"
                v-for="(v, k) in item.activityLabelList"
                :key="k"
                v-show="k <= 1"
              >
                <span>{{ v }}</span>
              </div>
            </div>
          </div>
          <span class="li_small_title">{{ item.subtitle }}</span>
        </div>
        <div class="li_right" @click="toGamePlay(item)">
          <span>进入</span>
        </div>
      </div>
      <ImageList
        v-if="item.imageList && item.imageList.length > 0 && type=='game' && index<3"
        :imgList="item.imageList"
      />
    </div>
  </div>
</template>
<script>
import ImageList from "@/components/imageList.vue";
export default {
  name: "gameList",
  components: { ImageList },
  props: ["gameList",'type'],
  data() {
    return {};
  },
  created() {},
  mounted() {
  },
  methods: {
    toGame(id) {
      this.$router.push({ name: "game", query: { id: id } });
    },
    toGamePlay(item) {
      if(item.isSupportH5){
        window.location.href=item.pcUrl;
      }else{
         this.$router.push({ name: "game", query: { id: item.id } });
      }
      
    },
  },
};
</script>
<style lang="scss" scoped>
@mixin flex_box(
  $flex-direction: row,
  $justify-content: none,
  $align-items: none
) {
  display: flex;
  flex-direction: $flex-direction;
  justify-content: $justify-content;
  align-items: $align-items;
}
.gameList {
  @include flex_box(column, none, stretch);
  padding: 0 0.16rem;
  box-sizing: border-box;
  .li {
    // height: 1.38rem;
    // min-height: 1.38rem;
    border-bottom: 1px solid #e7e7e7;
    @include flex_box(column, none, stretch);
  }
  .top {
    @include flex_box(row, space-between, center);
    height: 1.38rem;
    min-height: 1.38rem;
  }
  .li_icon {
    width: 1.08rem;
    height: 1.08rem;
  }
  .li_middle {
    flex: 1;
    margin: 0 0.1rem;
    @include flex_box(column, center, stretch);
  }
  .li_middle_top {
    @include flex_box(row, space-between, center);
    font-size: 14px;
  }
  .li_title {
    color: #656565;
    font-size: 16px;
  }
  .li_gift_text {
    color: #ff913a;
  }
  .li_gift_type {
    flex: 1;
    overflow: hidden;
    @include flex_box(row, flex-start, center);
    border-radius: 2px;
    margin-top: -0.2rem;
  }
  .li_gift {
    @include flex_box(row, center, center);
    height: 0.26rem;
    background-color: #3aa2f2;

    font-size: 12px;
    color: #fff;
    overflow: hidden; /*内容超出后隐藏*/

    text-overflow: ellipsis; /* 超出内容显示为省略号 */

    white-space: nowrap; /* 文本不进行换行 */
    span {
      transform: scale(0.7);
      transform-origin: center center;
      line-height: 0.26rem;
      white-space: nowrap;
    }
  }
  .li_small_title {
    margin-top: 0.1rem;
    font-size: 12px;
    color: #999999;
    transform: scale(0.9);
    transform-origin: 0 center;
    width: 120%;
    text-align: left;
  }
  .li_right {
    @include flex_box(row, center, center);
    width: 1rem;
    height: 0.46rem;
    background-color: #ff913a;
    border-radius: 4px;
    color: #fff;
    font-size: 12px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/gameList.vue